import { useState } from "react";
import { useAlert } from "react-alert";
import "./EmailForm.css";
import axios from "axios";
export default function EmailFormV2() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const alert = useAlert();
  const handleSubmit = (e) => {
    e.preventDefault();
    if (name === "" || email === "" || message === "") {
      alert.show("Please enter all fields");
      return;
    }
    axios
      .post(
        // "http://localhost:5000/your-firebase-priject-id/us-central1/api/contact",
        process.env.REACT_APP_WEBSITE_CLOUD_FUNCTION_ENDPOINT_CONTACT_FORM,
        {
          name: name,
          email: email,
          message: message,
        }
      )
      .then((response) => {
        alert.show("Email delivered !");
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  return (
    <div div className="container">
      <form onSubmit={handleSubmit} className="emailForm">
        <div>
          <h1>Customer Service</h1>
          <br />
          We will be glad to assist
          <p>Please explain in detail what assistance you need</p>
          <input
            type="text"
            placeholder="Your Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <input
            type="email"
            placeholder="Your Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <textarea
            placeholder="Explain What you are contacting us for"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          ></textarea>
          <button type="submit">Send</button>
        </div>
      </form>
    </div>
  );
}
